import React, { useContext } from 'react';
import dayjs from 'dayjs';

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import WorkItem from './WorkItem';

import AuthContext from '../../../services/firebase/AuthContext';
const formatDate = ts => dayjs(ts).format('ddd D MMM YYYY h:mm a');

const CaseInfoView = ({ caseInfo }) => {
    const { currentUser: { uid }} = useContext(AuthContext);

    const {
        intermediaryId,
        caseReference,
        info: {
            courtCase,
            serviceUser: {
                name: vp = 'VP Name missing',
                age = 0,
                vulnerabilities = []
            } = {}
        } = {},
        referrer,
        work,
        note
    } = caseInfo;

    // currently the work pages use current user id so no point in showing links to other member's work
    const showWorkLinks = uid === intermediaryId;
    const { rfq, tariff, location, timesheet } = work[0];

    return (
        <Grid container direction='column' spacing={1}>
            <Grid item xs={4}>
                <Typography variant="button" color="secondary">{vp}</Typography>
            </Grid>
            {
                age > 0 &&
                <Grid item>
                    <Typography variant="body2" color="initial">Age {age}</Typography>
                </Grid>
            }
            <Grid item>
                <Typography variant="body2" color="initial">{
                    vulnerabilities.map(({ description }) => description).join(', ')
                }</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2" color="initial">Referred by {referrer?.user?.name} at {referrer?.organization?.name} on {formatDate(rfq.ts)}</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2">{
                    tariff === 'tier1' ? 'Family and all court work' : 'Defendant assessment / report (Legal Aid)'
                }</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2">{location?.name}</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2">Court: {courtCase?.court?.name || timesheet?.court?.name || 'TBD'} - Case Number {caseReference || 'TBD'}</Typography>
            </Grid>
            {
                note &&
                <Grid item>
                    <Typography variant="button">Notes from original referral</Typography>
                </Grid>
            }
            {
                note?.clientNeeds?.text &&
                <Grid item>
                    <Typography variant="body2">{note.clientNeeds.text}</Typography>
                </Grid>
            }
            {
                note?.dates?.text &&
                <Grid item>
                    <Typography variant="body2">{note?.dates?.text}</Typography>
                </Grid>
            }
            <Grid item>
                <Typography variant="button">CASE Work</Typography>
            </Grid>
            {
                work?.map((job, index) => {
                    return <Grid item key={`${job.reference}-${index}`}>
                        <WorkItem value={job} showWorkLinks={showWorkLinks}/>
                    </Grid>
                })
            }
        </Grid>
    );
};

export default CaseInfoView;